// Status codes shared by audits and bookings, with the label and colour each one shows as.

const AUDIT = {
  0: ['Vendor assignment pending', 'amber'],
  1: ['Vendor assigned', 'blue'],
  2: ['Vendor accepted', 'blue'],
  3: ['Employee assigned', 'violet'],
  4: ['Audit complete', 'violet'],
  5: ['Price finalized', 'amber'],
  6: ['Audit accepted', 'green'],
  '-1': ['Cancelled by admin', 'red'],
  '-2': ['Cancelled by user', 'red'],
  '-3': ['Cancelled by user', 'red'],
};

const BOOKING = {
  0: ['Vendor assignment pending', 'amber'],
  1: ['Vendor assigned', 'blue'],
  2: ['Vendor accepted', 'blue'],
  3: ['Employee assigned', 'violet'],
  4: ['Service complete', 'green'],
  5: ['Reviewed', 'green'],
  '-1': ['Cancelled by admin', 'red'],
  '-2': ['Cancelled by user', 'red'],
};

const lookup = (table) => (code) => {
  const [label, tone] = table[code] || ['Unknown', 'gray'];
  return { label, tone };
};

export const auditStatus = lookup(AUDIT);
export const bookingStatus = lookup(BOOKING);
